<template>
  <v-dialog
      v-model="modal"
      max-width="795"
  >
    <v-card class="nv-dialog">
      <div class="nv-dialog__header">
        <span class="nv-dialog__icon"><v-icon color="secondary">mdi-file-document-edit-outline</v-icon></span>
        <h4 class="nv-dialog__title">Kullanıcı Sözleşmesi</h4>
        <v-spacer></v-spacer>
        <v-btn icon small @click="modal = false" aria-label="Kapat">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text class="pa-0">
        <div class="contract">
          <div class="contract__content">
            <div id="print">
              <div class="contract__contentTitle">
                <img src="/logo.png">
                <h3>NİLVERA YAZILIM VE BİLİŞİM HİZMETLERİ TİC. LTD. ŞTİ.</h3>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 20px">
                <h4>E-DÖNÜŞÜM HİZMET SÖZLEŞMESİ</h4>
              </div>
              <div style="margin-top: 20px">
                <b>1-TARAFLAR</b><br>
                <div style="margin-left: 10px">
                  <b>1.1. NİLVERA YAZILIM VE BİLİŞİM HİZMETLERİ TİCARET LTD.ŞTİ.</b><br>
                  <b>(bundan sonra kısaca “NİLVERA” olarak anılacaktır)</b>
                  <table border="1" class="contract__contentTable">
                    <tr>
                      <td colspan="2">İMZA YETKİLİSİ</td>
                    </tr>
                    <tr style="height: 50px">
                      <td style="width: 180px">Ad/Soyad/T.C. Kimlik No</td>
                      <td>HAMZA CECİKOĞLU / 50155331306</td>
                    </tr>
                    <tr style="height: 70px">
                      <td>ADRES</td>
                      <td>Yıldırım Beyazıt Mah. Aşık Veysel Bul. Erciyes Teknopark 3. Bina No: 67/32 Melikgazi / KAYSERİ</td>
                    </tr>
                    <tr>
                      <td>TEL/FAKS/WEB/E-MAİL</td>
                      <td>08502514010 / www.nilvera.com / destek@nilvera.com</td>
                    </tr>
                    <tr>
                      <td>VERGİ DAİRESİ/VERGİ NO</td>
                      <td>ERCİYES / 6310540565</td>
                    </tr>
                  </table>
                </div>
                <div style="margin-left: 10px">
                  <b>1.2. (bundan böyle kısaca “MÜŞTERİ” olarak anılacaktır)</b>
                  <table border="1" class="contract__contentTable">
                    <tr>
                      <td colspan="2">FİRMA BİLGİLERİ</td>
                    </tr>
                    <tr style="height: 50px">
                      <td style="width: 180px">Firma Adı</td>
                      <td>{{ value.Name }}</td>
                    </tr>
                    <tr style="height: 70px">
                      <td>ADRES</td>
                      <td>{{ value.Address.Address }}</td>
                    </tr>
                    <tr>
                      <td>TEL/FAKS/WEB/E-MAİL</td>
                      <td>
                        <span v-if="this.companyPhone">{{ this.companyPhone.replace(/[\s()]/g, '') }}</span>
                        <span v-if="value.Address.Fax"> / {{ value.Address.Fax }}</span>
                        <span v-if="value.Address.WebSite"> / {{ value.Address.WebSite }}</span>
                        <span v-if="value.Address.Email"> / {{ value.Address.Email }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>VERGİ DAİRESİ/{{ value.TaxNumber.length == 10 ? 'VERGİ NO' : 'T.C. KİMLİK NO' }}</td>
                      <td>
                        <span v-if="value.Address.TaxOffice">{{ value.Address.TaxOffice }} / </span>
                        <span v-if="value.TaxNumber">{{ value.TaxNumber }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div style="margin-top: 20px">
                <b>2-AMAÇ VE KAPSAM</b><br>
                <p align="justify">İşbu sözleşmenin imza tarihinde yürürlükte olan, Yasa Koyucu, Gelir İdaresi
                  Başkanlığı
                  (kısaca “GİB”) ve
                  yetkili otoriteler tarafından yapılan yasal düzenlemeler (kısaca “mevzuat”) kapsamında, NİLVERA
                  tarafından
                  geliştirilen ve kurulan elektronik platformda yer alan/yer alacak MÜŞTERİ’nin, <b>e-fatura, e-arşiv,
                    e-irsaliye, e-smm ,e-müstahsil,</b> ve <b>raporu</b> (kısaca e-belge ) oluşturma, gönderme,
                  onaylama,
                  arşivleme, saklama, destek ve eğitim hizmetlerinden yararlanmasını sağlamaya yönelik uygulama
                  esaslarını;
                  anılan hizmetler için belirlenecek koşulları; sözleşmenin süresini; tarafların sözleşmeden
                  doğan/doğacak
                  hak
                  ve yükümlülüklerini ve sair hususları düzenlemektedir.</p>
              </div>
              <div style="margin-top: 20px">
                <b>3-SÖZLEŞMENİN SÜRESİ</b><br>
                <p align="justify"><b>3.1</b> İşbu Sözleşme, imza tarihi itibariyle yürürlüğe girip <b>1 (bir) yıl</b>
                  sürelidir. <b>Sözleşme
                    bitiş
                    tarihinden en az 1 (bir) ay önce MÜŞTERİ tarafından yazılı fesih ihbarı yapılmaması durumunda
                    kendiliğinden önce 1 (bir) yıl sonra devam eden yıllar süresince yenilenir.</b> Sözleşme bu şekilde
                  yenilendiği takdirde, yenileme tarihinde yürürlükte olan ücret tarifesine göre revize edilerek
                  uygulanacaktır. Sözleşmenin kendiliğinden uzaması ve NİLVERA tarafından faturalama işleminin
                  yapılmasından
                  sonra MÜŞTERİ tarafından deaktivasyon ( Kapatma ) talebi olması durumunda, sözleşmenin yenilenmesinin
                  üzerinden geçen süreye bakılmaksızın MÜŞTERİ kendisine kesilen fatura tutarının tamamını ödemeyi
                  gayrikabili rücu olarak kabul, beyan ve taahhüt eder.</p>
              </div>
              <div style="margin-top: 20px">
                <b>4-TARAFLARIN YÜKÜMLÜLÜKLERİ</b><br>
                <b>4.1 NİLVERA</b><br>
                <p align="justify"><b>4.1.1</b> NİLVERA, gerekli koşulları yerine getirerek, başvurusunu tamamlamış ve
                  GİB’den
                  onay almış
                  MÜŞTERİ’ye e-dönüşüm Platformu ve/veya MÜŞTERİ’nin kullanmakta olduğu muhasebe programı üzerinden işbu
                  Sözleşme hükümlerine uygun olarak hizmet verecek, elektronik platformda kullanılmak üzere MÜŞTERİ’ye
                  özel
                  kullanıcı hesabı açacak, kullanıcı ad(lar)ı ve şifre(ler) sağlayacaktır. MÜŞTERİ’ye ait özel kullanıcı
                  hesabı, bilgi güvenliği koşullarında belirtilen standartlara uygun olarak yönetilecek ve muhafaza
                  edilecektir. MÜŞTERİ’nin yasal mevzuatta belirtilen usul ve esaslara uygun olarak e-belge
                  düzenlemesine,
                  saklamasına, içeriğine ulaşmasına GİB tarafından belirlenmiş format ve standartlara uygun olarak
                  aracılık
                  edecektir.<br>
                  <b>4.1.2</b> NİLVERA’nın, MÜŞTERİ’nin yazılı talebi doğrultusunda, MÜŞTERİ’ye özel yapacağı ilave
                  proje,
                  yazılım
                  ve sair çalışmaları için tarafların mutabakatı doğrultusunda MÜŞTERİ’den ek ücret talep etme hakkı
                  saklıdır.<br>
                  <b>4.1.3</b> Üçüncü kişilerin MÜŞTERİ’ye sundukları internet ve telekomünikasyon hizmetlerindeki
                  aksaklıklar, veri
                  aktarımı ve bağlantı sorunları, MÜŞTERİ nezdinde kullanılmakta olan bilgisayar, ekipman ve donanımın
                  iyi
                  bir
                  şekilde çalışmaması nedeniyle MÜŞTERİ’nin e-dönüşüm Platformu’na erişmekte zorlanması ya da hiç
                  erişememesinden NİLVERA sorumlu tutulamayacaktır.<br>
                  <b>4.1.4</b> NİLVERA, MÜŞTERİ ile çalıştığı süre boyunca MÜŞTERİ’ye ait E-Belge verilerini mevzuat
                  gereği 10
                  (on)
                  sene süre ile saklamakla yükümlüdür. Taraflar arasındaki sözleşmenin bu yükümlülüğün sona ermesinden
                  önce
                  kendiliğinden sona ermesi ya da feshedilmesi halinde, MÜŞTERİ e-dönüşüm Platformu üzerinden 3 iş günü
                  içerisinde kendisine ait bilgi, belge ve verileri sistem üzerinden indirecektir ve MÜŞTERİ’nin sisteme
                  erişimi kapatılacaktır. MÜŞTERİ’nin sisteme erişime devam etme talebi olur ise, NİLVERA’nın buna
                  ilişkin
                  hizmet bedeli talep hakkı saklıdır.</p>
              </div>
              <div style="margin-top: 20px">
                <b>4.2 MÜŞTERİ</b><br>
                <p align="justify"><b>4.2.1</b> MÜŞTERİ, GİB’e ve diğer kurumlara yapılması gereken başvuru süreçlerini
                  NİLVERA sistemi
                  kanalıyla proje takvimine uygun şekilde gerçekleştirmeyi kabul, beyan ve taahhüt eder. <br>
                  <b>4.2.2</b> MÜŞTERİ, e-dönüşüm Platformu üzerinden yapacağı işlemlerde yürürlükteki mevzuata uygun
                  nitelikte ve mahiyette e- belge düzenleyeceğini, e-belge gönderme işlemlerinde de aynı mevzuat
                  koşullarına
                  istisnasız riayet edeceğini, mevzuata aykırı hareket edilmesi halinde NİLVERA’nın hiçbir sorumluluğu
                  olmayacağını, e-dönüşüm Platformu üzerinde MÜŞTERİ’nin yetki verdiği Yetkili Kullanıcılar’ın yaptığı
                  tüm
                  işlemlerde doğrudan muhatabın kendisinin olduğunu, NİLVERA’nın işbu sözleşme hükümleri çerçevesinde
                  verdiği/verecek olduğu hizmetlerde veri iletimi, rapor gönderimi, yönünde sistemsel sorumluluğu
                  bulunduğunu,
                  Yetkili Kullanıcı bazında yapılan hatalı işlemlerden kaynaklanabilecek her türlü sorunda hukuki ve
                  cezai
                  sorumluluğun doğrudan MÜŞTERİ sıfatı ile kendisine olduğunu, gayrikabili rücu olarak kabul, beyan ve
                  taahhüt
                  eder.<br>
                  <b>4.2.3</b> MÜŞTERİ, E-Belgelerinin, e-dönüşüm Platformu üzerinde NİLVERA’nın mali mühür sertifikası
                  ile NİLVERA tarafından MÜŞTERİ adına onaylanacağını bildiğini ve işbu sözleşme tahtında bu duruma
                  muvafakat
                  ettiğini gayrikabilirücu olarak kabul, beyan ve taahhüt eder.</p>
              </div>
              <div style="margin-top: 20px">
                <b>5-HİZMET BEDELİ, MASRAFLAR VE ÖDEME ŞEKLİ</b><br>
                <p align="justify"><b>5.1</b> MÜŞTERİ, NİLVERA ile imzaladığı işbu Sözleşme’de yer alan Fiyat
                  Listesi’nde
                  belirlenen veya
                  daha sonra eklenebilecek hizmet/işlem/ürünler ve NİLVERA’nın bildirimleri nedeni ile gereken her türlü
                  masraf, ücret, komisyon, vergi, vergi benzeri diğer mali yükümlülüklerin kendisine ait olduğunu,
                  NİLVERA’nın
                  bunları herhangi bir şekilde ödemek durumunda kalması halinde talep üzerine derhal nakden NİLVERA’ya
                  ödeyeceğini kabul, beyan ve taahhüt eder.<br>
                  <b>5.2</b> İşbu Sözleşme kapsamında NİLVERA’nın sunduğu E-Dönüşüm hizmetleri bedeli, 15.Madde‘de
                  belirtilen
                  kriterlere göre hesaplanacak ve ödenecektir.<br>
                  <b>5.3</b> İşbu Sözleşmeden kaynaklanan ödemeler belirtilen NİLVERA’nın hesabına, belirtilen süre ve
                  şekilde ödenecektir.<br>
                  <b>5.4</b> MÜŞTERİ, işbu sözleşmeden kaynaklanan ödeme yükümlülüğünü süresinde yapmadığı ya da eksik
                  yaptığı takdirde önceden hiçbir ihtara gerek kalmaksızın temerrüde düşmüş sayılacak ve alacağa Türkiye
                  Merkez Bankası tarafından açıklanan, temerrüt tarihindeki en yüksek
                  ticari avans faizi işletilecektir. NİLVERA’nın bu sebeple uğrayacağı her tür zarar ve ziyanını tazmin
                  ve
                  sözleşmeyi tek taraflı derhal fesih hakkı saklıdır.<br>
                  <b>5.5</b> Müşteri’nin işbu Sözleşme kapsamında fatura veya sair bedellere ilişkin ödemelerinin tam ve
                  zamanında yapılmaması halinde hiçbir ihtara gerek kalmaksızın işbu Sözleşmeyi tek taraflı olarak sona
                  erdirebilir. <br>
                  <b>5.6</b>
                  NİLVERA ücretlerin ödenmemesi sebebiyle ödeme yapılıncaya kadar Hizmetleri
                  durdurabilir
                  ve/veya
                  askıya alabilir. NİLVERA , fesih tarihi sonuna kadar olan hizmet bedellerinin tahsili için her türlü
                  yasal
                  yola başvurma hakkına sahiptir.<br>
                  <b>5.7</b>
                  İşbu sözleşme devam ettiği sürece Müşteri Nilvera tarafından kendisine kesilecek yıllık hizmet ve
                  destek
                  bedeli faturasını ödemeyi gayrikabili rücu olarak kabul, beyan ve taahhüt eder.
                </p>
              </div>
              <div style="margin-top: 20px">
                <b>6-SÖZLEŞMENİN FESHİ</b><br>
                <p align="justify"><b>6.1</b> İşbu Sözleşmenin herhangi bir nedenle sona ermesi halinde; NİLVERA
                  tarafından
                  MÜŞTERİ’ye
                  sağlanan hizmet durdurulacaktır. Proje kapsamındaki programlar ise kullanılamaz hale gelecektir.<br>
                  <b>6.2</b> İşbu Sözleşmenin herhangi bir nedenle sona ermesi halinde MÜŞTERİ, sözleşmeden kaynaklanan
                  hizmet bedelini NİLVERA’ya ödemekle yükümlüdür. Müşteri tarafından iş bu sözleşmenin yegane tek
                  taraflı
                  fesih ön koşulu NİLVERA’ya olan bakiye borçlarını nakden ödemiş olması halidir. Bu bedel ödenmeden
                  fesih
                  ihbar geçerlilik arz etmeyecektir.<br>
                  <b>6.3</b> NİLVERA ve/veya MÜŞTERİ’nin işbu sözleşmede belirtilen yükümlülüklerini yerine getirmemesi
                  ve/veya getirememesi durumunda, hakkı ihlal edilen taraf, ihlal eden Taraf’a yapacağı yazılı
                  bildirimle,
                  ihlalin giderilmesi için 30 (otuz) günlük süre verecektir. Ancak ihlalin bu süre içerisinde de
                  giderilmemesi
                  halinde hakkı ihlal edilen taraf, diğer tarafa yazılı fesih ihbarında bulunmak suretiyle tazminat
                  ödemekle
                  yükümlü olmaksızın ve tek taraflı olarak işbu Sözleşme’yi feshedebilir.<br>
                  <b>6.4</b> Müşteri, Nilvera tarafından sağlanan e-Dönüşüm hizmetleri kapsamında kullanılan kredi bakiyesi eksi (–) durumda iken, talep edeceği herhangi bir deaktivasyon işleminin veya sözleşme feshi bildiriminin, kredi bakiyesi nötr (0) veya pozitif duruma geçmeden işleme alınamayacağını ve bu taleplerin geçerlilik kazanmayacağını kabul, beyan ve taahhüt eder.
                  Bu durumda Nilvera, müşteriye uygun en düşük kontör paketini sunmakla yükümlüdür.
                  Deaktivasyon işlemi ve/veya sözleşme feshi, ancak müşterinin kredi bakiyesinin nötr veya pozitif duruma geçmesinin ardından, müşteri talebi üzerine gerçekleştirilecektir.<br>
                  <b>6.5</b> Müşteri, Nilvera tarafından kendisine sağlanan sistem üzerinden tüm elektronik verilerini (fatura içerikleri, belgeler, imza değerleri vb.) eksiksiz, tam ve imza değerleri korunmuş şekilde teslim aldığını kabul, beyan ve taahhüt eder.<br>
                  <b>6.6</b> Nilvera, fesih tarihinden itibaren 30 (otuz) gün boyunca sistemde yer alan verilerin güvenli bir şekilde saklanmasından sorumludur. Bu sürenin sonunda, sistemde yer alan tüm veriler kalıcı olarak silinecek ve Müşteri’nin sisteme ve bu verilere erişimi tamamen kapatılacaktır. Müşteri, bu süreden sonra herhangi bir şekilde veriye erişimin mümkün olmayacağını bildiğini, bu hususta tüm sorumluluğun kendisine ait olduğunu kabul, beyan ve taahhüt eder.</p>
              </div>
              <div style="margin-top: 20px">
                <b>7-DİĞER HÜKÜMLER</b><br>
                <p align="justify"><b>7.1 Devir Yasağı:</b> MÜŞTERİ; NİLVERA’nın yazılı izni olmaksızın işbu
                  Sözleşme’den
                  doğan hak, alacak ve
                  yükümlülüklerini herhangi gerçek ya da tüzel kişilere kısmen veya tamamen devredemez; bedelli veya
                  bedelsiz
                  üçüncü kişilerin yararlanmasına, kullanımına sunamaz. <br>
                  <b>7.1.1</b> MÜŞTERİ’nin faaliyetlerinden vazgeçmesi, faaliyetlerini durdurması, faaliyetlerini ifa
                  etme
                  niteliğini yitirmesi, faaliyetlerinin başka bir tüzel kişiliğe devri, iflas etmesi, konkordato ilan
                  etmesi,
                  kayyuma devredilmesi gibi durumlardan herhangi birinin işbu Sözleşmenin garanti veya Bakım-Destek
                  şartlarının geçerli olduğu süre içinde gerçekleşmesi halinde, NİLVERA’nın Yazılım Güncelleme ve
                  Bakım-Destek
                  Hizmeti taahhüdü ile Yazılım garantisi kendiliğinden sona erer.<br>
                  <b>7.1.2</b> Tarafların iş bu Sözleşme'den kaynaklanan haklarını kullanmaması, Taraflarca yazılı
                  olarak
                  diğer Taraf'a bildirilmediği sürece, Sözleşme'nin herhangi bir hükmünün Taraflara sağlamış olduğu
                  haklardan
                  açıkça vazgeçtiği veya sahip olduğu hakları kullanmaktan feragat ettiği şeklinde yorumlanamaz.<br>
                  <b>7.1.3</b>
                  İşbu sözleşme elektronik olarak Mali Mühür ve/veya E-İmza ile imzalanır. Taraflar bu yöntem ile
                  imzalanmış sözleşmeyi kabul etmiş olduğunu kabul ve beyan eder.
                </p>
              </div>
              <div style="margin-top: 20px">
                <b>8-GİZLİLİK</b><br>
                <p align="justify"><b>8.1</b> Sayılanlarla sınırlı olmaksızın, bu ticari ilişki, hizmet ve sözleşme
                  vesilesi
                  ile doğrudan veya
                  dolaylı olarak öğrenilen şirket hesapları; şirket, müşteri, basın, tedarikçi ve çalışan bilgileri;
                  sözleşmeler, şahsi ilişkiler, yazışmalar, teklifler, fiyat politikaları, teknik şartnameler,
                  çizelgeler,
                  istatistikler; proje kapsamında verilen tüm bilgi, belge, sektörel bilgi bankası, tasarım, program,
                  işleyiş
                  ve fonksiyon bilgileri; taraflardan birinin kendisi, işçileri, acentaları ya da çalışanlarınca diğer
                  tarafın
                  işçileri, acentaları ya da çalışanlarına açıklanan her türlü bilgi, buluş, iş, metot, ilerleme ve
                  patent,
                  telif hakkı, marka, ticari sır; yasal korumaya konu olamasa bile diğer her türlü yenilik ve tarafların
                  aralarındaki ticari ilişki esnasında yazılı ya da sözlü yoldan öğrenecekleri tüm ticari, mali, teknik
                  bilgiler, abonelik ve konuşma bilgileri, “gizli bilgi” olarak kabul edilir. <br>
                  <b>8.2</b> Taraflar ilişkilerinin gerektirdiği ölçüde gizli bilgilerini birbirlerine açıklamak
                  durumundadırlar. Taraflardan her biri diğer tarafça kendisine açıklanan gizli bilgilerin eksik ya da
                  hatalı
                  olmasından sorumlu tutulamayacaklarını kabul ve taahhüt ederler. Taraflar kendilerine diğer tarafça
                  açıklanan bu gizli bilgiyi; <br><b>a)</b> Büyük bir gizlilik içinde korumayı; <b>b)</b> Herhangi bir
                  3.
                  Kişiye hangi suretle
                  olursa olsun vermemeyi ve/veya alenileştirmemeyi; <b>c)</b> Doğrudan ya da dolaylı olarak aralarındaki
                  ticari
                  ilişkinin amaçları dışında kullanmamayı taahhüt ederler.<br>
                  <b>8.3</b> Taraflar kendi gizli bilgilerini korumakta gösterdikleri özenin aynısını karşı tarafın
                  gizli
                  bilgilerini korumakta da göstermeyi kabul ve taahhüt ederler. Taraflar ancak zorunlu hallerde ve işi
                  gereği
                  bu bilgiyi, öğrenmesi gereken işçilerine, alt çalışanlarına ve kendilerine bağlı olarak çalışan diğer
                  kişilere verebilirler ancak bilginin gizliliği hususunda işçilerini, alt çalışanlarını ve kendilerine
                  bağlı
                  olarak çalışan diğer kişileri uyarırlar. Taraflar işçilerinin, alt çalışanlarının ve kendilerine bağlı
                  olarak çalışan diğer kişilerin işbu sözleşme yükümlülüklerine aykırı davranmayacaklarını ve böyle
                  davranmaları halinde çalışanları ile birlikte müştereken ve müteselsilen, doğrudan sorumlu
                  olacaklarını
                  peşinen kabul ve taahhüt ederler. <b>a)</b> Kamuya mal olmuş bilgiler <b>b)</b> Yürürlükte olan kanun
                  ya
                  da
                  düzenlemeler
                  ya da verilmiş olan bir mahkeme kararı, idari emir gereğince açıklanması gereken bilgiler
                  gizli
                  bilgi
                  kapsamında değildir.<br>
                  <b>8.4</b> Taraflardan biri sorumlu olduğu kişilerce diğer tarafa ait gizli bilgilerin sözleşmeye
                  aykırı
                  biçimde açıklandığından haberdar olduğunda, derhal ve her hâlükârda öğrenme tarihinden itibaren en geç
                  7
                  (yedi) işgünü içinde ve yazılı olarak karşı tarafa durumu bildirmekle yükümlüdür.<br>
                  <b>8.5</b> Gizli bilgileri sözleşmeye aykırı olarak açıklanmış taraf, bu bildirim üzerine veya
                  kendiliğinden masrafları diğer tarafa ait olmak kaydıyla tüm yasal yollara başvurma ve uğradığı her
                  türlü
                  zararın giderimini diğer taraftan talep etme hakkına sahiptir.<br>
                  <b>8.6</b> Gizli bilgiler içeren her türlü materyal, taraflar arasındaki ticari ilişkinin ya da işbu
                  sözleşmenin sona ermesi halinde ve karşı tarafın yazılı ihtarı üzerine, derhal ve her hâlükârda
                  öğrenme
                  tarihinden itibaren en geç 7 (yedi) işgünü içinde bu bilgilerin ait olduğu tarafa iade edilir.<br>
                  <b>8.7</b> Taraflardan hiçbiri, işbu sözleşmenin sona ermesi halinde dahi, diğerinin yazılı izni
                  olmaksızın kanunda açıkça belirtilen haller dışında, bu bilgiyi 3. kişilere aktaramaz herhangi bir
                  şekilde
                  ya da herhangi bir yolla dağıtamaz, basın-yayın-sosyal medya organları vasıtasıyla açıklayamaz, reklam
                  amacıyla kullanamaz.<br>
                  <b>8.8</b> NİLVERA, 6698 Sayılı Kişisel Verilerin Korunması Hakkında Kanun kapsamında tüm hak ve
                  yükümlülüklerini yerine getirmeyi kabul ve taahhüt etmektedir. Kanun kapsamında: <br>
                  <b>8.9</b> İşbu sözleşmelerin imzalanması, NİLVERA sistemine giriş için gerekli yetkili kullanıcıların
                  belirlenmesi gibi işlemlerin yetkili kişilerce yapıldığını tespit etmek amacıyla ilgili kişilerin
                  kimlik,
                  adres ve gerekli diğer bilgi ve verileri;<br>
                  <b>8.10</b> Değişiklik ve güncellemelerden sizleri haberdar etmek, alınan hizmetin detaylarını,
                  kişisel
                  veri sahiplerini ve/veya müşterilerimizi, iş ortaklarımızı ilgilendirecek değişiklikleri ve
                  bilgilendirmeleri yapmak amacıyla ilgili kişilerin iletişim bilgi ve verileri;<br>
                  <b>8.11</b> Şirketimizin faaliyet konusu kapsamında gerekli işlemleri yapabilmemiz için Gelir İdaresi
                  Başkanlığı gibi kamu ve özel otoriteler tarafından temin edilmesi yasal zorunluluk teşkil eden ilgili
                  kişilere ait her tür bilgi ve verileri;<br>
                  <b>8.12</b> İş ortaklarımız, bayilerimiz ve diğer anlaşmalı kuruluşlar tarafından müşterilerimize
                  hizmet sunabilmek ve sunulan bu hizmete ilişkin müşterilerimizi bilgilendirebilmek amacıyla ilgili
                  kişilere
                  ait kaydedilen bilgi ve verileri;<br>
                  <b>8.13</b> İmzalanan sözleşmelerimizin ifası amacıyla edimlerimizi yerine getirmek için ilgili
                  kişilere
                  ait
                  istenilen bilgi ve verileri;<br>
                  <b>8.14</b> Rızası bulunan müşterilerimize ve/veya veri sahibi ilgili kişilere reklam, kampanyalar ve
                  özel fırsatlardan haberdar etmek amacıyla edinilen bilgi ve verileri;<br>
                  <b>8.15</b> Şikâyet, öneri ve müşteri memnuniyetinin tespiti amacıyla anket yapmak amacıyla edinilen
                  ilgili kişiye ait bilgi ve verileri;<br>
                  <b>8.16</b> Rızası bulunan ve teklif sunulan müşteriler ile tekrar iletişime geçmek amacıyla
                  kaydedilen
                  ilgili kişilere ait bilgi ve verilerinin tamamen veya kısmen otomatik olan ya da herhangi bir veri
                  kayıt
                  sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi, depolanması,
                  muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde
                  edilebilir hâle getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler
                  üzerinde
                  gerçekleştirilen her türlü işlem yasa kapsamına girmektedir ve hukuka uygunluk teşkil ettiği MÜŞTERİ
                  tarafından kabul edilmiş ve işbu sözleşmenin imzalanmasıyla açıkça rıza gösterdiğini beyan
                  etmiştir.<br>
                  <b>8.17</b> KVKK kapsamında NİLVERA, yasal yükümlülükleri ve mevzuattan doğan hakları haricinde,
                  MÜŞTERİ’ye, yetkililerine ve çalışanlarına ait kişisel verileri, ancak veri sahibinin rızası dahilinde
                  yurt
                  içindeki ve yurt dışındaki üçüncü kişilere aktarmaktadır.<br>
                  <b>8.18</b> MÜŞTERİ’ye, yetkililerine ve çalışanlarına ait kişisel veriler sadece NİLVERA’nın ticari
                  faaliyetlerini yürütebilmesi adına NİLVERA’ya, iş ortaklarına ve anlaşmalı olduğu kamu ve özel kurum
                  ve
                  kuruluşlara veri aktarımı yapılabilmektedir. NİLVERA, bulut sistemi kullandığından, temin edilen
                  verilerin
                  bulut ortamında saklanması, anket ve ticari elektronik iletilerin gönderilmesi konusunda hizmet aldığı
                  ve
                  anlaşmalı olduğu yurt içi ve yurt dışı hizmet sağlayıcılarına, tedarikçilerine aktarım
                  yapılabilmektedir. Bu
                  nedenle, kişisel verilerin, bu sistemlere kaydedilmesiyle yurtdışında bulunan bu sunucular ile de
                  paylaşılmış olacağını ve fakat verilerin korunması için gerekli her tür teknik ve hukuki önlemlerin
                  mevzuat
                  kapsamında, en üst düzeyde temin edilmiş olduğunu NİLVERA kabul ve taahhüt etmektedir. İşbu sözleşme
                  ile
                  MÜŞTERİ yurt içinde ve yurt dışında verilerinin mevzuata ve hukuka uygun şekilde aktarılabileceğini
                  bildiğini ve işbu sözleşmenin imzalanmasıyla açıkça rıza gösterdiğini beyan etmektedir. KVKK md. 11
                  kapsamında müşterinin, yetkililerinin ve çalışanlarının hakları saklıdır.<br>
                  <b>8.19</b> Taraflardan her biri personelinin, alt çalışanlarının ve kendisine bağlı olarak çalışan
                  diğer kişilerin kişisel verilere erişim ve işleme yetkilerini kişisel verilere ilişkin mevzuata uygun
                  olarak
                  tanımlayacağını; personelinin, alt çalışanlarının ve kendisine bağlı olarak çalışan diğer kişilerin
                  tanımlanan erişim yetkilerini kullanarak erişilen bilgileri ve erişim için kullandığı
                  şifreleri/metotları
                  hiç kimse ile paylaşmamasını sağlayacağını; personeline, alt çalışanlarına ve kendisine bağlı olarak
                  çalışan
                  diğer kişilere Kanun ve ilgili mevzuatta belirtilen yükümlülükleri kapsamında bilgilendirme
                  yapacağını,
                  bu
                  Sözleşme’nin imzasından sonra personelinin, alt çalışanlarının ve kendisine bağlı olarak çalışan diğer
                  kişilerin işbu Sözleşme’de belirtilen yükümlülüklere aykırı davranmayacaklarını ve böyle davranmaları
                  halinde idari para cezaları dahil ve fakat bununla sınırlı olmamak üzere doğacak her türlü doğrudan
                  zarardan
                  doğrudan sorumlu olacağını kabul ve beyan eder.<br>
                  <b>8.20</b> Bizzat MÜŞTERİ tarafından temin edilen ve NİLVERA ile sözleşmenin ifası nedeniyle
                  paylaşılan kişisel verilerin KVKK yönünden hukuka uygun olarak tamamen veya kısmen otomatik olan ya da
                  herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi,
                  kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması,
                  aktarılması, devralınması, elde edilebilir hale getirilmesi, sınıflandırılması ya da kullanılmasının
                  engellenmesi gibi veriler üzerinde gerçekleştirilen her tür işlem ve eylem yönünden hukuki, idari ve
                  cezai
                  sorumluluk MÜŞTERİ’ye ait olduğunu kabul, taahhüt ve beyan etmektedir. <br>
                  <b>8.21 NİLVERA</b> tarafından iş bu sözleşmede yazılı bütün maddeler MÜŞTERİYE okunup, izah
                  edilmiştir.
                  MÜŞTERİ , tüm maddelerde geçen kişisel verilerinin otomatik ya da otomatik olmayan yollarla
                  kaydedilmesine,
                  saklanmasına, işlenmesine, tasniflenmesine, açıklanmasına, aktarılmasına, anonim hale getirilmesi ve
                  devredilmesine, E-Dönüşüm Sistemlerinin ( E-Fatura, E-Arşiv, E-smm, E-mm, E-saklama ,E-irsaliye,
                  E-Defter,
                  E-Saklama vb. diğer tüm ürünlerinin) geliştirilmesinin ve düzgün bir şekilde çalışmasının
                  sağlanmasına,
                  hizmetlerin ve ürünlerinin iyileştirmesinin sağlanmasına, verilen hizmetler ile alakalı kullanımın
                  kolaylaştırılması amacı ile kullanıcı ara yüzlerinin ve yazılımların değiştirilmesine, satış ve
                  pazarlama
                  faaliyetlerinin yürütülebilmesi, her türlü iletişim aracına uygun bildirimin sağlanabilmesi,
                  kullanılan
                  yazılım, program ve ara yüzlere ait her türlü teknik desteğin verilmesine, MÜŞTERİ’nin kullanmakta
                  veya
                  kullanacak olduğu özel entegratör ile aktivasyon/de aktivasyon ( açma ve kapama ) vb. işlemlerinde
                  süre
                  ile
                  sınırlı olmaksızın NİLVERA’nın yetkili olduğuna, GİB (Gelir İdaresi Başkanlığı) ile yapılacak tüm
                  başvuru ve
                  işlemlerde NİLVERA’nın yetkilendirildiğine ve NİLVERA’nın yazılı onay ve izni olmaksızın
                  devredilemeyeceğine, kendi özgür iradesiyle ve rızasıyla onay vermiş ve kabul etmiştir.<br>
                  <b>8.22 MÜŞTERİ</b> Mali, ekonomik, sözleşme ve/veya alınan hizmet konusu e-dönüşüm ürünleri
                  ile ilgili evrak, belge, fotoğraf, iletişim bilgileri vs., Irk, etnik köken, siyasi düşünce, felsefi
                  inanç,
                  dini, mezhep veya diğer inançlar, kılık ve kıyafet, dernek, vakıf ya da sendika üyeliği, sağlık,
                  cinsel
                  hayat, sabıka kaydı ve güvenlik tedbirleriyle ilgili veriler ile biyometrik ve genetik veriler vb.
                  özel
                  nitelikli kişisel verileri kendi özgür iradesiyle, kullanım yeri, kullanacağı alan hakkında gerekli
                  yasal
                  bilgi verilerek ve rızasıyla kanuni amaçlar doğrultusunda kullanılmak üzere NİLVERA’ya vermiştir.<br>
                </p>
              </div>
              <div style="margin-top: 20px">
                <b>9-FİKRİ MÜLKİYET HAKLARI</b><br>
                <p align="justify">Taraflar işbu sözleşme konusu iş ile ilgili diğer tarafa temin edilmiş veya edilecek
                  her
                  türlü ürün, bilgi,
                  belge, mal, hizmet üzerinde yer alan her türlü fikri mülkiyet hakkının mezkur tarafa ait olduğunu ve
                  diğer
                  tarafın kendisinin de bunlar üzerinde hiçbir hak veya çıkarı bulunmadığını kabul, beyan ve taahhüt
                  eder.</p>
              </div>
              <div style="margin-top: 20px">
                <b>10-TEBLİGAT</b><br>
                <p align="justify">Taraflar işbu sözleşme konusu iş ile ilgili diğer tarafa temin edilmiş veya edilecek
                  her
                  türlü ürün, bilgi,
                  belge, mal, hizmet üzerinde yer alan her türlü fikri mülkiyet hakkının mezkur tarafa ait olduğunu ve
                  diğer
                  tarafın kendisinin de bunlar üzerinde hiçbir hak veya çıkarı bulunmadığını kabul, beyan ve taahhüt
                  eder.</p>
              </div>
              <div style="margin-top: 20px">
                <b>11-MÜCBİR SEBEP</b><br>
                <p align="justify">Mücbir Sebep, bu sebebin mağduru olan tarafın hatası, kusuru veya ihmali olmaksızın,
                  öngörülemez ve karşı
                  konulamaz nitelikteki olgular anlamına gelir.<br>
                  <b>11.1</b> İşbu Sözleşme’de aksi belirtilmedikçe, taraflar, yükümlülüklerini yerine getirmelerinin
                  mücbir
                  sebep nedeniyle engellenmesi veya alıkonması ölçüsünde, Sözleşme’den doğan yükümlülüklerini ifada
                  temerrüde
                  düşmüş sayılmayacaklardır.<br>
                  <b>11.2</b> Mücbir sebep halinde mağdur taraf (i) diğer tarafı derhal ve her halükarda en geç 7 (yedi)
                  işgünü
                  içerisinde yazılı olarak haberdar edecek, edimin ifa edilememesinin sebebini ortadan kaldırmak için
                  gereken
                  tüm çabayı sarf edecek, (iii) diğer taraf bu sebep ortadan kalkıncaya kadar akdi yükümlülüklerinden
                  azade
                  tutulmak üzere, bu sebep ortadan kalkar kalkmaz edimlerinin tümünü ifa edecektir.<br>
                  <b>11.3</b> Mücbir sebepler ortadan kalkınca Taraflar işbu Sözleşmeyi mücbir sebebin meydana gelmesi
                  öncesinde kalmış olduğu yerden devam ettirecektir. Mücbir sebebin 45 (kırkbeş) günden fazla sürmesi
                  halinde,
                  her iki taraf da Sözleşme’yi herhangi bir tazminat ödemeksizin ve yazılı olarak bildirmek suretiyle
                  feshedebilir.<br></p>
              </div>
              <div style="margin-top: 20px">
                <b>12-KISMEN GEÇERSİZLİK</b><br>
                <p align="justify">İşbu Sözleşme hükümlerinden herhangi birisinin, kısmen veya tamamen hukuken geçersiz
                  olması
                  veya icra
                  kabiliyetinin olmaması, diğer Sözleşme hükümlerinin geçerliliğini ve yürürlüğünü etkilemez.</p>
              </div>
              <div style="margin-top: 20px">
                <b>13-SÖZLEŞME’DE DEĞİŞİKLİK</b><br>
                <p align="justify">İşbu Sözleşme ancak tarafların muvafakati ile ve yazılı olarak değiştirilebilir.</p>
              </div>
              <div style="margin-top: 20px">
                <b>14-BÜTÜNLÜK</b><br>
                <p align="justify">Sözleşme ekleri Sözleşme’nin ayrılmaz parçalarıdır ve Sözleşme ile birlikte bir bütün
                  olarak
                  değerlendirilir.<br>
                  <b>a. Delil:</b> İşbu Sözleşme süresi içinde NİLVERA, MÜŞTERİ’ye tahsis ettiği ya da MÜŞTERİ
                  tarafından
                  kullanılan elektronik posta adresine mesaj, bilgi, yazı, ihtar, ödeme bildirimi, hesap hareket
                  çizelgesi,
                  hesap ekstresi gönderebilir. MÜŞTERİ, söz konusu elektronik iletilerin alınmadığı ya da kendisine
                  ulaşmadığı
                  iddiasında bulunamayacağı gibi, söz konusu iletilerin gönderildikleri tarihten 1 (bir) işgünü sonra
                  yasal
                  anlamda tebliğ etmiş sayılacağını beyan, kabul ve taahhüt eder.
                  Taraflar, işbu sözleşmeden doğacak ihtilaflarda; tarafların elektronik ve fiziki defter kayıtlarının,
                  bilgisayar kayıtlarının, tarafların göndermiş olduğu elektronik posta ve benzeri iletilerle tarafların
                  İnternet ortamında yaptığı bilgisayarlarında depolanmış kayıtlarının 6100 sayılı Hukuk Muhakemeleri
                  Kanunu’nun 193. maddesi anlamında geçerli, bağlayıcı, kesin ve öncelikli delil teşkil edeceğini ve bu
                  maddenin delil sözleşmesi niteliğinde olduğunu peşinen kabul, beyan ve taahhüt ederler.<br>
                  <b>b. Yetkili Mahkeme:</b> Taraflar arasında işbu Sözleşme’den doğabilecek uyuşmazlıklarda Kayseri
                  Mahkemeleri ve İcra
                  Daireleri yetkilidir.<br>
                  <b>c. Vergi ve Yükümlülükler:</b> İşbu sözleşmeden doğan damga vergisi, diğer vergi ve yükümlülükler
                  MÜŞTERİ
                  tarafından karşılanacaktır.<br>
                  <b>d. Yürürlük:</b> İşbu Altı ( 6 ) sayfadan ibaret Sözleşme, tarafların karşılıklı mutabakatı
                  ile 1 (bir) nüsha olarak düzenlenmiş, okunmuş, anlaşılmış ve imzaları ile onaylanarak aynı tarihte
                  yürürlüğe
                  girmiştir. <br>
                </p>
              </div>
              <div style="margin-top: 20px">
                <b>15-FATURALANDIRMA ve ÖDEME KOŞULLARI</b><br>
                <p align="justify"><b>a. </b> MÜŞTERİ, yukarıda 2.1. maddede belirtilen “Çözüm, Danışmanlık ve Kurulum
                  Hizmetleri” bedelinin
                  %50’sini Sözleşme’nin imza tarihinden itibaren en geç bir hafta içerisinde peşin olarak, kalan tutarı
                  ise,
                  kurulum hizmetleri tamamlandıktan sonra düzenlenen fatura mukabilinde ve fatura tarihinden itibaren en
                  geç 5
                  (beş) gün içinde ödemeyi kabul ve taahhüt eder.<br><br>
                  <b>Açıklamalar</b><br>
                  <b>1) </b> E-Belge : Her bir gönderilen "E-belge" adeti 1 kontör olarak hesaplanır.<br>
                  <b>2) </b> e-Mail Gönderimi: e-Mail gönderimi ücretsiz olup sınırsız olarak mail gönderimi
                  yapılabilir.<br>
                  <b>3) </b> Eğitim ve Destek: Uzaktan eğitim ve teknik destek hizmetleri sürekli olarak
                  verilecektir.<br>
                  <b>4) </b> Fiyatlarımıza vergiler dahil değildir.<br>
                </p>
              </div>
              <div style="margin-top: 20px">
                <b>Alınan Modüller:</b> {{ currentModules.join(', ') }}
              </div>
              <div style="margin-top: 20px;display: flex;align-items: center;justify-content: space-around">
                <div>Bu sözleşme elektronik olarak Mali Mühür ve/veya E-İmza ile imzalanmıştır.</div>
                <div id="qrcode">[qrcode]</div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import html2pdf from "html2pdf.js"
import qrcode from "qrcode"

export default {
  name: "Contract",
  props: ["value", "selectedModules", "companyPhone"],
  data() {
    return {
      modal: false,
      modules: [
        {key: 'EInvoice', value: 'E-Fatura'},
        {key: 'EArchive', value: 'E-Arşiv'},
        {key: 'EDespatch', value: 'E-İrsaliye'},
        {key: 'EMM', value: 'E-MM'},
        {key: 'ESMM', value: 'E-SMM'},
        {key: 'EBill', value: 'E-Adisyon'},
        {key: 'EInsurance', value: 'E-Sigorta'},
        {key: 'ECurrency', value: 'E-Döviz'},
        {key: 'Expense', value: 'E-Gider Pusulası'},
      ],
      currentModules: []
    }
  },
  methods: {
    async contractModalOpen() {
      await (this.modal = true)
      this.generateQRCode()
    },
    async contractDownload() {
      await (this.modal = true)
      this.generateQRCode()
      const itemToPrint = document.querySelector("#print")
      this.modal = false
      const opt = {
        margin: [32, 32],
        filename: "Sözleşme.pdf",
        html2canvas: {scale: 2, letterRendering: true},
        jsPDF: {unit: 'pt', format: 'letter', orientation: 'portrait'},
        pagebreak: {mode: ['avoid-all', 'css', 'legacy']}
      }
      await html2pdf().from(itemToPrint).set(opt).save()
      this.$router.push("/dashboard")
    },
    generateQRCode() {
      this.currentModules = []
      this.selectedModules.forEach((x) => {
        this.currentModules.push(this.modules.find(y => y.key == x).value)
      })
      let model = {
        "Firma Adı": this.value.Name,
        "Alınan Modüller": this.currentModules.join(', '),
        "Sözleşme Tarihi": new Date().toLocaleString('tr')
      }
      this.value.TaxNumber.length == 10 ? (model["Vergi No"] = this.value.TaxNumber) : (model["T.C. Kimlik No"] = `/` + this.value.TaxNumber + `/`)
      qrcode.toString(JSON.stringify(model), {width: 130}, function (err, code) {
        if (err) return console.log(err)
        document.querySelector("#qrcode").innerHTML = code
      })
    }
  }
}
</script>

<style scoped>

</style>